
import { Component, Input, OnInit } from '@angular/core';
import { DateHelper } from '../../../../../../helpers';
import { ETimetablePattern } from '../../../../../../model';
import { ITerminal } from '../../../../../../modules/olaqin/models/iterminal';
import { EDeviceType } from '../../../../shared/enums/EDeviceType';


@Component({
  selector: 'di-objet-lecteur',
  templateUrl: './objet-lecteur.component.html',
  styleUrls: ['./objet-lecteur.component.scss'],
})
export class ObjetLecteurComponent implements OnInit {
  
  @Input() terminal: ITerminal;
  @Input() cetAppareil: boolean = false;

  public deviceColor: string;
  public deviceType: string;
  public lastUsedDate: string;

  constructor() {}

  ngOnInit() {
    this.deviceColor = this.getOsTagColor();
    this.deviceType = this.getDisplayedDeviceType();
    this.lastUsedDate = this.terminal.lastUsedDate ? "Dernière utilisation: " + DateHelper.transform(this.terminal.lastUsedDate, ETimetablePattern.EEEE_dd_MMMM) + ' à ' + DateHelper.transform(this.terminal.lastUsedDate, ETimetablePattern.HH_mm) : "Jamais utilisé";
  }

  getOsTagColor(): string {
    switch (this.terminal.device) {
      case EDeviceType.WINDOWS:
        return 'BleuVif';
      case EDeviceType.ANDROID:
        return 'Vert';
      case EDeviceType.MACOS:
        return 'Rouge';
      case EDeviceType.IOS:
        return 'Orange';
      default:
        return 'CouleurPrimaire';
    }
  }

  getDisplayedDeviceType(): string {
    switch(this.terminal.device){
      case EDeviceType.WINDOWS:
        return 'Windows';
      case EDeviceType.ANDROID:
        return 'Android';
      case EDeviceType.MACOS:
        return 'MacOS';
      case EDeviceType.IOS:
        return 'iOS';
      default:
        return '';
    }
  }

}
